import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Documents } from 'src/app/classes/Documents/documents';
import { ModulesManagerService } from 'src/app/classes/Module/modules-manager.service';
import SwiperCore, { SwiperOptions, Zoom } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
SwiperCore.use([Zoom])
@Component({
  selector: 'app-photo-viewer',
  templateUrl: './photo-viewer.page.html',
  styleUrls: ['./photo-viewer.page.scss'],
  standalone: false
})
export class PhotoViewerPage implements OnInit {
  @ViewChild('swiper') swiper: SwiperComponent;
  @Input() document: Documents
  config: SwiperOptions = {
    zoom: {
      maxRatio: 10,
      minRatio: 1,
      toggle: true
    }
  }
  constructor(public manager: ModulesManagerService) { }

  ngOnInit() {
  }

  zoom(zoomIn) {
    zoomIn ? this.swiper.swiperRef.zoom.in() : this.swiper.swiperRef.zoom.out()

  }

  reset() {
    this.swiper.swiperRef.zoom.out()
  }

  close() {
    this.manager.closeModal()
  }

}
